export const DefaultLogo = "/web-common-resource/assets/images/KYLIN-LOGO.png";

export const DefaultSecondaryLogo =
  "/web-common-resource/assets/images/KYLIN-SECONDARY-LOGO.png";
